import * as React from 'react';
import { Loader } from '@sunbit-dev/web-ui-lib';
import { LoaderContext } from '../contexts/loaderContext'

const LoaderContainer = (_props) => {
  const {isLoaderOn} = React.useContext(LoaderContext);
  return <Loader active={ isLoaderOn } />
}

export default LoaderContainer
